import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getDependentInvitesForUser = () =>
  call(websocketFetch, 'get_dependent_invites_for_user');
